import { useMutation, useQueryClient } from 'react-query'

import { toast } from '@/models/toasts'
import { teamService } from '@/modules/team/service/team-service.ts'
import { handleError } from '@/utils/error'

import type { UpdateCreatorAccessRequest } from '../types'

export const useUpdateCreatorAccess = (creatorId: number) => {
  const queryClient = useQueryClient()

  const updateCreatorAccessMutation = useMutation(
    (data: UpdateCreatorAccessRequest) =>
      teamService.updateCreatorAccess(creatorId, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['creatorAccess', creatorId])
        toast.success('Successfully updated creator access')
      },
      onError: (error) => {
        handleError(error, 'Failed to update creator access')
      },
    },
  )

  return {
    updateCreatorAccessMutation,
  }
}
